import $ from 'jquery';
import delay from '../delay';
import { setupURLParamTogglers } from 'javascripts/util/url_param_toggler';

let logIntoAhaWindow = null;
window.afterPopupLogin = function () {
  if (window.waitingForOpenerLogin) {
    window.waitingForOpenerLogin = false;
    $('.popover.active').trigger('portalUserReady').removeClass('active');
    setTimeout(() => window.location.reload(), 150); // Allow the vote or subscription action to complete before triggering the reload.
  }
};

$.fn.rebind = function (eventName, ...args) {
  this.off(eventName);
  return this.on(eventName, ...args);
};

// Make menu collapsed by default in mobile view
const hideRollup = function () {
  if ($(window).width() <= 670) {
    $('#sidebar-rollup.in').removeClass('in');
    $('.btn-navbar').addClass('collapsed');
  }
};

$(document).on('page:change', function () {
  hideRollup();
  setupURLParamTogglers();
});

$(function () {
  hideRollup();

  $(document).on('click', '.btn-navbar', function (event) {
    const $elem = $(this);
    $elem.toggleClass('is-shown');
    $elem.next('#sidebar-rollup').toggleClass('in');
  });

  // Enable attachment uploads.
  iripo.in(
    '.attachment-button, .attachment-link',
    node => {
      $(node).fileUploader({
        url: `/idea_portals/${$('meta[name=portal-token]').attr('content')}${$(
          node
        ).data('upload-url')}`,
        dropzoneScope: $(node).data('drop-zone-scope'),
        acceptFiles: $(node).data('supported-file-types'),
      });
    },
    true // Process the callback immediately after instantiation
  );

  // Category hints
  $(document).popover({
    selector: 'i.fa-circle-question',
    trigger: 'hover focus',
    delay,
  });

  // Poll counts
  $(document).popover({
    selector: '.idea-portal-section__grid i.fa-user-check',
    trigger: 'hover focus',
    delay,
  });

  $(document).on('click', '.log-into-aha', function (event) {
    window.waitingForOpenerLogin = true;
    if (logIntoAhaWindow) {
      logIntoAhaWindow.focus();
    } else {
      const url = $(this).attr('data-login-url');
      const width = 950;
      const height = 600;
      const left = screen.width / 2 - width / 2;
      const top = screen.height / 2 - height / 2;
      const windowFeatures = `location=0,status=0,width=${width},height=${height},top=${top},left=${left}`;
      logIntoAhaWindow = window.open(url, 'Login in with Aha!', windowFeatures);
    }
  });

  try {
    if (window.opener) {
      window.opener.afterPopupLogin();
      window.close();
    }
  } catch (error) {}
  // Nothing

  iripo.in('.modal', function (node) {
    // Enable modal dragging
    if ($(node).hasClass('undraggable')) {
      return;
    }

    $(node).draggable({
      handle: '.modal-header,aha-modal-header',
      scroll: false,
      cancel: 'input,textarea,button,select,option,.btn',
      alters: 'margin', // Add new option to adjust margin instead of top/left when dragging. This works significantly better with popover's native positioning strategy and doesn't have the downsides of using transform/translate or top/left adjustments.
    });
  });
});

// For a <select data-show-color> tag, when an option is selected, set the appropriate color/background-color of the <select>.
iripo.in('select[data-show-color]', function (node) {
  if (!node.multiple) {
    updateSelectColors(node);
    node.addEventListener('change', function (event) {
      updateSelectColors(event.target);
    });
  }
});

// We set these as CSS variables rather than directly as style properties so that:
// 1. We can easily override these colors in the CSS if necessary.
// 2. If we happen to pass an invalid color, the browser will ignore it and use the default color.
//    This is better than breaking the UI by making the text illegible.
function updateSelectColors(node) {
  const selectedOptions = node.selectedOptions;
  if (selectedOptions.length > 0) {
    const opt = selectedOptions[0];

    // Set color of the select.
    if (opt.dataset.selectedColor) {
      node.style.setProperty('--selected-color', opt.dataset.selectedColor);
    }

    // Set background color of the select.
    if (opt.dataset.selectedBackgroundColor) {
      node.style.setProperty(
        '--selected-background-color',
        opt.dataset.selectedBackgroundColor
      );
    }
  } else {
    node.style.removeProperty('--selected-color');
    node.style.removeProperty('--selected-background-color');
  }
}
